export const meetupDate = '2025-06-20';
export const meetupStartTime = '13:00';
export const timeZone = 'CET';
export const formName = 'ai-and-china-roadshow-2025-rotterdam';

export const initialCoordinates = {
  lat: 51.89822211783341,
  lng: 4.419047146860249,
};

export const markerSettings = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'AI, Data and Trade War: Lessons From China',
  address: 'De Loft, Scheepsbouwweg 8, 3089 JW Rotterdam, Netherlands',
  link: 'https://maps.app.goo.gl/egcbJGrPyJJZJowC9',
};
